// frontend/src/components/ViewtransactionModal.tsx
import { Dialog, DialogContent, DialogTitle } from "@/components/ui/dialog";
import { PTxContent } from "./types";

interface ViewTransactionModalProps {
  transaction: PTxContent;
  onClose: () => void;
}

export default function ViewPTxModal({
  transaction,
  onClose,
}: ViewTransactionModalProps): JSX.Element {
  return (
    <Dialog open onOpenChange={onClose}>
      <DialogContent>
        <div className="mb-4">
          <DialogTitle className="text-lg font-bold">
            Transaction Details
          </DialogTitle>
        </div>
        <div className="space-y-1">
          <p>
            <strong>Version:</strong> {transaction.__v}
          </p>
          <p>
            <strong>ID:</strong> {transaction._id}
          </p>
          <p>
            <strong>Amount:</strong> {transaction.amount}
          </p>
          <p>
            <strong>Channel:</strong> {transaction.channel}
          </p>
          <p>
            <strong>Currency:</strong> {transaction.currency}
          </p>
          <p>
            <strong>Customer Code:</strong> {transaction.customerCode}
          </p>
          <p>
            <strong>Fees:</strong> {transaction.fees}
          </p>
          <p>
            <strong>Message:</strong> {transaction.message}
          </p>
          <p>
            <strong>Paid At:</strong> {transaction.paidAt}
          </p>
          <p>
            <strong>Primary Key:</strong> {transaction.primaryKey}
          </p>
          <p>
            <strong>Received At:</strong> {transaction.receivedAt}
          </p>
          <p>
            <strong>Received Date:</strong> {transaction.receivedDate}
          </p>
          <p>
            <strong>Received Time:</strong> {transaction.receivedTime}
          </p>
          <p>
            <strong>Reference:</strong> {transaction.reference}
          </p>
          <p>
            <strong>Requested Amount:</strong> {transaction.requestedAmount}
          </p>
          <p>
            <strong>Terminal ID:</strong> {transaction.terminalId}
          </p>
          <p>
            <strong>Type:</strong> {transaction.type}
          </p>
        </div>
      </DialogContent>
    </Dialog>
  );
}
